import { Box, Grid, Link } from '@mui/material';

import { FOOTER_LABEL } from 'common/constants';
import {
	APP_RISK_LINK_FOOTER_LINK_COOKIE,
	APP_RISK_LINK_FOOTER_LINK_PRIVACY,
	APP_RISK_LINK_FOOTER_LINK_UNIVERSAL,
} from 'common/constants/TextContent';

import styles from 'features/common/Common.module.scss';

const { link: universalLink, label: universalLabel } =
	APP_RISK_LINK_FOOTER_LINK_UNIVERSAL;
const { link: privacyLink, label: privacyLabel } =
	APP_RISK_LINK_FOOTER_LINK_PRIVACY;
const { link: cookieLink, label: cookieLabel } =
	APP_RISK_LINK_FOOTER_LINK_COOKIE;

interface IFooterProps {
	isLandingFooter?: boolean;
}

const Footer = ({ isLandingFooter }: IFooterProps) => {
	const date = new Date();
	const year = date.getFullYear();
	const boxClassName =
		styles[`footer-text-box${isLandingFooter ? '-landing' : ''}`];
	const footerLabel = ` ${year} ${FOOTER_LABEL}`;

	return (
		<Grid
			container
			direction="column"
			alignItems={isLandingFooter ? 'center' : 'normal'}
		>
			<Box className={boxClassName}>&copy;{footerLabel}</Box>
			<Box className={boxClassName}>
				<Link href={universalLink} target="_blank">
					{universalLabel}
				</Link>
				<Box className={styles['footer-link-divider']}>|</Box>
				<Link href={privacyLink} target="_blank">
					{privacyLabel}
				</Link>
				<Box className={styles['footer-link-divider']}>|</Box>
				<Link href={cookieLink} target="_blank">
					{cookieLabel}
				</Link>
			</Box>
		</Grid>
	);
};

export default Footer;
